import { GA_MEASUREMENT_ID } from "./constants";

export const pageview = () => {
  window.gtag("config", GA_MEASUREMENT_ID, {
    page_path: url,
  });
};

export const gtagEvent = ({ action, category, label, value }) => {
  if(window && window.gtag){
  window.gtag("event", action, {
    event_category: category,
      event_label: label,
      value,
    });
  }
};
